import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react'

import { Card as AdminCard } from '@iws/admin-ui/card'

import { cn } from '@/lib/utils'

export { CardContent, CardHeader, CardTitle } from '@iws/admin-ui/card'

/** The admin card with the POS radius (8px). */
export const Card = forwardRef<ElementRef<typeof AdminCard>, ComponentPropsWithoutRef<typeof AdminCard>>(({ className, ...props }, ref) => (
  <AdminCard ref={ref} className={cn('rounded-md', className)} {...props} />
))
Card.displayName = 'Card'
